import Vue from 'vue';

Vue.filter('amount', function (value) {
  if (!value) return '';
  if (typeof value !== 'string' && typeof value !== 'number') return  '';
  const [integer, decimal] = (value || 0).toString().split('.')
  return `${
    decimal
      ? [
          integer.toString().replace(/(\d{1,3})(?=(\d{3})+$)/g, '$1,'),
          decimal,
        ].join('.')
      : integer.toString().replace(/(\d{1,3})(?=(\d{3})+$)/g, '$1,')
  }`
})
